module.exports = __webpack_public_path__ + "img/nevi_hero_mobile_EA_Baker_Gen4144.6d78c47d.png";